/**
 * APOs matching these titles will be hidden from the user on product pages
 *
 * Should partially match contents of title attribute of mw-option image
 * img.mw-option__swatch-image[title*="WB-PFA19"]
 *
 * Note: Title can contain more (its a partial match)
 * Matching is case insensitive.
 */

// window.outOfStockSKUs is set in theme.liquid
const OUT_OF_STOCK_SKUS = globalThis.outOfStockSKUs;
console.log('out of stock skus:', OUT_OF_STOCK_SKUS);


document.addEventListener('DOMContentLoaded', findAndHideOutOfStockAPOs);

// The number of seconds to continue trying to find APO options after the DOM loads
const STOP_SEARCHING_AFTER_SECONDS = 10;

function findAndHideOutOfStockAPOs() {
  const foundAPOList = searchForApoList();

  foundAPOList
    .then(hideOutOfStockApos)
    .catch((e) => console.log(e))
}

function searchForApoList() {
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (document.querySelector('.mw-apo-container')) {
        clearInterval(interval);
        clearTimeout(timeout);
        resolve();
      }
    }, 200)
    const timeout = setTimeout(() => {
      reject('Timed out looking for advanced product options...');
      clearInterval(interval);
    }, STOP_SEARCHING_AFTER_SECONDS * 1000);
  });
}

/**
 * @param {boolean} [force] - If true, will force a re-search of the DOM
 * @param baseElement {Document | Element}
 */
function hideOutOfStockApos(force = true, baseElement = document) {
  baseElement.querySelectorAll('img.mw-option__swatch-image').forEach((titleEl) => {
    const title = titleEl.getAttribute('title');
    const isOutOfStock = OUT_OF_STOCK_SKUS.find(sku => title.toLowerCase().trim().indexOf(sku.toLowerCase().trim()) !== -1)
    if (isOutOfStock) {
      titleEl.closest('.mw-option__value').classList.add('mw-hidden');
      const closestMWOption = titleEl.closest('.mw-option')
      const closestMWOptionHidden = !!closestMWOption.classList.contains('mw-hidden')
      if (closestMWOptionHidden && force) {
        watchForHiddenConditionalOptions(closestMWOption);
      }
    }
  })
}
function watchForHiddenConditionalOptions(element) {
  const observer = useMutationObserver()
  observer.observe(element, { attributes: true });
}

/**
 * Gets a singleton mutation observer for the DOM
 * @returns {MutationObserver}
 */
function useMutationObserver() {
  // create a observer singleton on the window
  if (!globalThis.jodApoHiderMutationObserver) {
    globalThis.jodApoHiderMutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // type is HTMLElement
          const mwOption = /** @type {HTMLElement} */(mutation.target);
          const mwOptionHidden = !!mwOption.classList.contains('mw-hidden')
          if (!mwOptionHidden) {
            hideOutOfStockApos(false, mwOption);
          }
        }
      })
    });
  }
  return globalThis.jodApoHiderMutationObserver;
}


